import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "reactstrap";
import moment from "moment";

//Helpers
import mascaras from "../../../../helpers/mascaras";
import { showMessage } from "../../../../helpers/message";

//Components
import TextField from "../../../../components/TextField";
import { EmailTagsInput } from "../../../../components/EmailTagsInput";
import ModalCustomized from "../../../../components/Modal/Modal";
import { actionsTable } from "../../../../constants/MaterialTable";
import TabelaListagem from "../../../../components/TabelaListagem/TabelaListagem";
import Anexo from "../../../../components/Anexo";

//Api
import cep_api from "../../../../api/cep_api";
import regional_api from "../../../../api/regional_api";
import fiscalizacao_api from "../../../../api/fiscalizacao_api";
import integracao_api from "../../../../api/integracao_api";

//Context
import { useAuth } from "../../../../context/auth";


function Identificacao({
  dadosIntegracao,
  execucaoFiscalizacao,
  setExecucaoFiscalizacao,
  errors,
  indicarEndereco,
  disabled,
  solicitacaoImages = [],
  setDadosIntegracao = null,
  disabledCamposDadosFalecido,
  exibirDadosObitor,
}) {
  const { setLoading } = useAuth();

  const [disabledCamposEndereco, setDisabledCamposEndereco] = useState({
    cep: false,
    cidade: false,
    uf: false,
    logradouro: false,
    bairro: false,
    numeroLogradouro: false,
  });

  //Estado para pegar todas regionais
  const [listRegionais, setListRegionais] = useState([]);

  const [openModalSelecionarInfrator, setOpenModalSelecionarInfrator] = useState(false);
  const [listInfratores, setListInfratores] = useState([]);
  const docConfirmadoRef = useRef(null); // último CNPJ já resolvido (selecionado ou match único)

  const headersInfratores = [
    { value: "CNES", objectValue: "cnes", align: "left" },
    { value: "Razão Social", objectValue: "nomeRazao", align: "left" },
    {
      value: "Endereço", objectValue: "endereco", align: "left", options: {
        customBodyRenderLite: (dataIndex) => {
          return <>{listInfratores[dataIndex].logradouro_Infrator}, {listInfratores[dataIndex].numeroLogradouro_Infrator},  {listInfratores[dataIndex].bairro_Infrator}</>
        }
      }
    },
  ];

  //onChange dos campos de identificação
  const onChange = (e) => {
    const { name, value } = e.target;
    const currentDate = new Date().toISOString().slice(0, 10); // Obtém a data atual no formato 'YYYY-MM-DD'

    if (
      name === "dataFiscalizacao" &&
      moment(value).isAfter(currentDate, "day")
    ) {
      showMessage(
        "Aviso",
        "Por favor, selecione uma data válida (até o dia atual).",
        "warning",
        null
      );
      return;
    }

    setExecucaoFiscalizacao({
      ...execucaoFiscalizacao,
      [name]: value,
    });
  };

  //onChange dos campos do infrator
  const onChangeInfrator = (e) => {
    const { name, value } = e.target;
    if (name === "documentoIdentificacao") {
      docConfirmadoRef.current = null; // usuário editou o CNPJ, permite nova busca
    }
    setExecucaoFiscalizacao({
      ...execucaoFiscalizacao,
      infrator: {
        ...execucaoFiscalizacao.infrator,
        [name]: value,
      },
    });
  };

  //Função de onblur do campo de cep
  const onBlurCepLocal = (e) => {
    const { name, value } = e.target;
    const _cep = mascaras.cepMask(value, true);

    if (_cep.length === 8) {
      setLoading(true);
      cep_api
        .get(_cep)
        .then((response) => {
          let _execucaoFiscalizacao = {
            ...execucaoFiscalizacao,
            uf: response.data.uf,
            cidade: response.data.localidade,
            bairro: response.data.bairro,
            logradouro: response.data.logradouro,
          };

          if (execucaoFiscalizacao.indicarEndereco || indicarEndereco) {
            const endereco = {
              Cep: _cep,
              Bairro: response.data.bairro,
              Logradouro: response.data.logradouro,
              Cidade: response.data.localidade,
              Estado: execucaoFiscalizacao.uf,
              Numero: execucaoFiscalizacao.numeroLogradouro,
              Latitude: "",
              Longitude: "",
              EnderecoFormatado: "",
            };
            cep_api
              .GeoCode(endereco)
              .then((response) => {
                if (response.data.latitude && response.data.longitude) {
                  _execucaoFiscalizacao.latitude = parseFloat(
                    response.data.latitude.replace(",", ".")
                  );
                  _execucaoFiscalizacao.longitude = parseFloat(
                    response.data.longitude.replace(",", ".")
                  );
                }
                setExecucaoFiscalizacao(_execucaoFiscalizacao);
              })
              .catch((err) =>
                showMessage(
                  "Error",
                  err?.message ?? "Error na operação.",
                  "error",
                  null
                )
              )
              .finally((f) => setLoading(false));
          } else {
            setExecucaoFiscalizacao(_execucaoFiscalizacao);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          showMessage(
            "Error",
            err?.message ?? "Error na operação.",
            "error",
            null
          );
        });
    }
  };

  // Função chamada no onBlur do campo de CEP
  const onBlurCepLocalInfrator = async (e) => {
    const { name, value } = e.target;
    const _cep = mascaras.cepMask(value, true);
    if (_cep.length !== 8) return;

    setLoading(true);

    try {
      const response = await cep_api.get(_cep);

      const { logradouro, bairro, localidade, uf } = response.data;
      const _execucaoFiscalizacao = {
        ...execucaoFiscalizacao,
        infrator: {
          ...execucaoFiscalizacao.infrator,
          logradouro_Infrator: logradouro,
          bairro_Infrator: bairro,
          cidade_Infrator: localidade,
          uf_Infrator: uf,
        },
      };
      setExecucaoFiscalizacao(_execucaoFiscalizacao);
    } catch (err) {
      showMessage(
        "Erro",
        err?.message ?? "Erro ao buscar dados do CEP.",
        "error",
        null
      );
    } finally {
      setLoading(false);
    }
  };

  const regionais = () => {
    setLoading(true);
    regional_api
      .getList()
      .then((response) => {
        response.data = response?.data?.map((value) => {
          value.value = value.id;
          value.label = value.identificacao;
          return value;
        });
        setListRegionais(response.data);
      })
      .catch((err) =>
        showMessage(
          "Error",
          err?.message ?? "Error na operação.",
          "error",
          null
        )
      )
      .finally(() => setLoading(false));
  };

  const preencherDadosInfrator = (item) => {
    const docResolvido =
      (item?.documentoIdentificacao && item.documentoIdentificacao.toString().trim() !== "")
        ? item.documentoIdentificacao
        : execucaoFiscalizacao?.infrator?.documentoIdentificacao ?? "";
    docConfirmadoRef.current = docResolvido;

    setExecucaoFiscalizacao((prev) => ({
      ...prev,
      emailsCC: item?.infratorEmailsCCs?.length > 0 ? item.infratorEmailsCCs : [],
      infrator: {
        infrator_Id: item?.infrator_Id ?? null,
        documentoIdentificacao:
          (item?.documentoIdentificacao && item.documentoIdentificacao.toString().trim() !== "")
            ? item.documentoIdentificacao
            : prev?.infrator?.documentoIdentificacao ?? "",
        nomeRazao: item?.nomeRazao ?? "",
        nomeFantasia: item?.nomeFantasia ?? "",
        email: item?.email ?? "",
        codigoCadastro: item?.codigoCadastro ?? "",
        cep_Infrator: item?.ceP_Infrator ?? "",
        logradouro_Infrator: item?.logradouro_Infrator ?? "",
        bairro_Infrator: item?.bairro_Infrator ?? "",
        numeroLogradouro_Infrator: item?.numeroLogradouro_Infrator ?? "",
        complemento_Infrator: item?.complemento_Infrator ?? "",
        cidade_Infrator: item?.cidade_Infrator ?? "",
        uf_Infrator: item?.uF_Infrator ?? "",
      },
    }));

    setDadosIntegracao((prev) => ({
      ...prev,
      dadosAdicionais: item?.dadosAdicionais ?? [],
    }));

    setOpenModalSelecionarInfrator(false);
  };

  const handleOnBlur = async (e) => {
    const doc = execucaoFiscalizacao.infrator.documentoIdentificacao;

    if (doc.length < 14) {
      showMessage(
        "Aviso",
        "O CNPJ informado é inválido. Por favor, corrija-o.",
        "warning",
        null
      );
      return;
    }

    if (doc === docConfirmadoRef.current) return; // CNPJ já resolvido, evita reabrir o modal

    setLoading(true);

    try {
      const { data } = await integracao_api.GetInfratorIntegracao(doc);

      if (data && data.length > 1) {
        setListInfratores(data);
        setOpenModalSelecionarInfrator(true);
      } else
        preencherDadosInfrator(data[0]);
    } catch (err) {
      showMessage("Erro", err?.message ?? "Erro na operação.", "error", null);
    } finally {
      setLoading(false);
    }
  };

  const handleOnBlurRegionalExecucaoFiscalizacao = (e) => {
    const { name, value } = e.target;
    if (!!value) {
      setLoading(true);
      fiscalizacao_api
        .PostRegionalExecucaoFiscalizacao({
          cep: name == "numeroLogradouro_Infrator" ? execucaoFiscalizacao.infrator.cep_Infrator : execucaoFiscalizacao.cep,
          bairro: name == "numeroLogradouro_Infrator" ? execucaoFiscalizacao.infrator.bairro_Infrator : execucaoFiscalizacao.bairro,
          logradouro: name == "numeroLogradouro_Infrator" ? execucaoFiscalizacao.infrator.logradouro_Infrator : execucaoFiscalizacao.logradouro,
          cidade: name == "numeroLogradouro_Infrator" ? execucaoFiscalizacao.infrator.cidade_Infrator : execucaoFiscalizacao.cidade,
          estado: name == "numeroLogradouro_Infrator" ? execucaoFiscalizacao.infrator.uf_Infrator : execucaoFiscalizacao.uf,
          numero: name == "numeroLogradouro_Infrator" ? execucaoFiscalizacao.infrator.numeroLogradouro_Infrator : execucaoFiscalizacao.numeroLogradouro,
          latitude: "",
          longitude: "",
          enderecoFormatado: "",
        })
        .then((response) => {
          if (response.data != 0)
            setExecucaoFiscalizacao((prev) => ({
              ...prev,
              regional_Id: response.data.toString(),
            }));
        })
        .catch((err) =>
          showMessage(
            "Error",
            err?.message ?? "Error na operação.",
            "error",
            null
          )
        )
        .finally(() => setLoading(false));
    }
  };

  function onChangeDadosObitos(e) {
    const { name, value } = e.target;

    setExecucaoFiscalizacao((prev) => ({
      ...prev,
      dadosFalecido: {
        ...prev.dadosFalecido,
        [name]: value,
      },
    }));
  }

  useEffect(() => {
    regionais();
  }, []);

  useEffect(() => {
    const doc = execucaoFiscalizacao?.infrator?.documentoIdentificacao;
    const semEndereco = !execucaoFiscalizacao?.infrator?.cep_Infrator;
    if (!doc || doc.length < 14 || !semEndereco) return;
    if (doc === docConfirmadoRef.current) return; // CNPJ já resolvido, evita reabrir o modal
    setLoading(true);
    integracao_api
      .GetInfratorIntegracao(doc)
      .then(({ data }) => {
        if (data && data.length > 1) {
          setListInfratores(data);
          setOpenModalSelecionarInfrator(true);
        } else {
          preencherDadosInfrator(data?.[0]);
        }
      })
      .catch((err) =>
        showMessage("Erro", err?.message ?? "Erro na operação.", "error", null)
      )
      .finally(() => setLoading(false));
  }, [execucaoFiscalizacao.infrator.documentoIdentificacao]);

  useEffect(() => {
    if (disabled && execucaoFiscalizacao) {
      setDisabledCamposEndereco({
        bairro: execucaoFiscalizacao.bairro != "",
        cep: execucaoFiscalizacao.cep != "",
        cidade: execucaoFiscalizacao.cidade != "",
        uf: execucaoFiscalizacao.uf != "",
        logradouro: execucaoFiscalizacao.logradouro != "",
        numeroLogradouro: execucaoFiscalizacao.numeroLogradouro != "",
      });
    }
  }, [execucaoFiscalizacao]);

  const actionsInfrator = [actionsTable.confirmar((rowData) => preencherDadosInfrator(rowData))];

  return (
    <>
      <ModalCustomized
        size={"xl"}
        isOpen={openModalSelecionarInfrator}
        toggle={() => {
          setExecucaoFiscalizacao({
            ...execucaoFiscalizacao,
            infrator: {
              ...execucaoFiscalizacao,
              documentoIdentificacao: "",
            },
          });
          setOpenModalSelecionarInfrator(!openModalSelecionarInfrator)
        }}
        title={"Selecione o Infrator"}
        btnClose={() => {
          setExecucaoFiscalizacao({
            ...execucaoFiscalizacao,
            infrator: {
              ...execucaoFiscalizacao.infrator,
              documentoIdentificacao: "",
            },
          });
          setOpenModalSelecionarInfrator(false);
        }}
      >
        <TabelaListagem
          title={"Infratores Encontrados"}
          headers={headersInfratores}
          items={listInfratores}
          actions={actionsInfrator}
          options={{ print: false, search: true, pagination: true }}
        />
      </ModalCustomized>

      <Row>
        <Col
          md="12"
          lg={!execucaoFiscalizacao.infrator.codigoCadastro ? "6" : "4"}
        >
          <TextField
            name="documentoIdentificacao"
            label={"* Documento de identificação"}
            value={execucaoFiscalizacao.infrator.documentoIdentificacao}
            mask={mascaras.cpfcnpjMask}
            onChange={onChangeInfrator}
            onBlur={handleOnBlur}
            invalid={!!errors.documentoIdentificacao}
            maxLength={18}
          />
        </Col>
        <Col
          md="12"
          lg={!execucaoFiscalizacao.infrator.codigoCadastro ? "6" : "5"}
        >
          <TextField
            name="email"
            label={"* E-mail"}
            value={execucaoFiscalizacao.infrator.email}
            onChange={onChangeInfrator}
            invalid={!!errors.email}
          />
        </Col>
        {execucaoFiscalizacao.infrator.codigoCadastro && (
          <Col md="12" lg="3">
            <TextField
              name="codigoCadastro"
              label={"* Código de cadastro"}
              value={execucaoFiscalizacao.infrator.codigoCadastro}
              onChange={onChangeInfrator}
              invalid={!!errors.codigoCadastro}
            />
          </Col>
        )}
        <Col md={12} lg={12}>
          <EmailTagsInput
            label="E-mail CC"
            state={execucaoFiscalizacao}
            setState={setExecucaoFiscalizacao}
          />
        </Col>

        <Col md="12" lg="12">
          <TextField
            name="nomeRazao"
            label={"* Nome / Razão social"}
            value={execucaoFiscalizacao.infrator.nomeRazao}
            onChange={onChangeInfrator}
            invalid={!!errors.nomeRazao}
          />
        </Col>
        <Col md="12" lg="12">
          <TextField
            name="nomeFantasia"
            label={"* Nome Fantasia"}
            value={execucaoFiscalizacao.infrator.nomeFantasia}
            onChange={onChangeInfrator}
            invalid={!!errors.nomeFantasia}
          />
        </Col>

        {solicitacaoImages.length > 0 && (
          <>
            <h5 className="p-2">Imagens</h5>
            <div className="d-flex gap-3 justify-content-center flex-wrap px-2 py-2">
              {solicitacaoImages.map((value, key) => (
                <Anexo key={key} anexo={value.nomeArquivo} label="Imagem da demanda" />
              ))}
            </div>
          </>
        )}
      </Row>

      <Row>
        <h5>Endereço do Infrator</h5>
        <Col md="12" lg="2">
          <TextField
            name="cep_Infrator"
            label={"* CEP"}
            value={execucaoFiscalizacao.infrator.cep_Infrator}
            onChange={onChangeInfrator}
            maxLength={9}
            mask={mascaras.cepMask}
            onBlur={onBlurCepLocalInfrator}
            disabled={disabledCamposEndereco.cep_Infrator}
            invalid={!!errors.cep_Infrator}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            name="cidade_Infrator"
            label={"* Cidade"}
            value={execucaoFiscalizacao.infrator.cidade_Infrator}
            onChange={onChangeInfrator}
            disabled={disabledCamposEndereco.cidade_Infrator}
            invalid={!!errors.cidade_Infrator}
          />
        </Col>
        <Col md="12" lg="1">
          <TextField
            name="uf_Infrator"
            label={"* UF"}
            value={execucaoFiscalizacao.infrator.uf_Infrator}
            onChange={onChangeInfrator}
            disabled={disabledCamposEndereco.uf_Infrator}
            invalid={!!errors.uf_Infrator}
          />
        </Col>
        <Col md="12" lg="5">
          <TextField
            name="logradouro_Infrator"
            label={"* Logradouro"}
            value={execucaoFiscalizacao.infrator.logradouro_Infrator}
            onChange={onChangeInfrator}
            disabled={disabledCamposEndereco.logradouro_Infrator}
            invalid={!!errors.logradouro_Infrator}
          />
        </Col>
        <Col md="12" lg="10">
          <TextField
            name="bairro_Infrator"
            label={"* Bairro"}
            value={execucaoFiscalizacao.infrator.bairro_Infrator}
            onChange={onChangeInfrator}
            disabled={disabledCamposEndereco.bairro_Infrator}
            invalid={!!errors.bairro_Infrator}
          />
        </Col>
        <Col md="12" lg="2">
          <TextField
            name="numeroLogradouro_Infrator"
            label={"* Número"}
            value={execucaoFiscalizacao.infrator.numeroLogradouro_Infrator}
            onBlur={handleOnBlurRegionalExecucaoFiscalizacao}
            onChange={onChangeInfrator}
            disabled={disabledCamposEndereco.numeroLogradouro_Infrator}
            invalid={!!errors.numeroLogradouro_Infrator}
          />
        </Col>
      </Row>

      <Row>
        <h5>Local da infração</h5>

        <Col md="12" lg={!!execucaoFiscalizacao.dataFlagrande ? 6 : 5}>
          <TextField
            name="dataFiscalizacao"
            label={"* Data/Hora da infração"}
            value={execucaoFiscalizacao.dataFiscalizacao}
            onChange={onChange}
            type={"datetime-local"}
            invalid={!!errors.dataFiscalizacao}
          />
        </Col>
        {execucaoFiscalizacao.dataFlagrande && (
          <Col md="12" lg="6">
            <TextField
              name="dataFlagrande"
              label={"Data do Flagrante:"}
              value={execucaoFiscalizacao.dataFlagrande}
              onChange={onChange}
              type={"datetime-local"}
              disabled={disabled}
            />
          </Col>
        )}

        <Col md="12" lg="2">
          <TextField
            name="cep"
            label={"* CEP"}
            value={execucaoFiscalizacao.cep}
            onChange={onChange}
            maxLength={9}
            mask={mascaras.cepMask}
            onBlur={onBlurCepLocal}
            invalid={!!errors.cep}
            disabled={disabledCamposEndereco.cep}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            name="cidade"
            label={"* Cidade"}
            value={execucaoFiscalizacao.cidade}
            onChange={onChange}
            invalid={!!errors.cidade}
            disabled={disabledCamposEndereco.cidade}
          />
        </Col>
        <Col md="12" lg="1">
          <TextField
            name="uf"
            label={"* UF"}
            value={execucaoFiscalizacao.uf}
            onChange={onChange}
            invalid={!!errors.uf}
            disabled={disabledCamposEndereco.uf}
          />
        </Col>
        <Col md="12" lg="5">
          <TextField
            name="logradouro"
            label={"* Logradouro"}
            value={execucaoFiscalizacao.logradouro}
            onChange={onChange}
            invalid={!!errors.logradouro}
            disabled={disabledCamposEndereco.logradouro}
          />
        </Col>
        <Col md="12" lg="5">
          <TextField
            name="bairro"
            label={"* Bairro"}
            value={execucaoFiscalizacao.bairro}
            onChange={onChange}
            invalid={!!errors.bairro}
            disabled={disabledCamposEndereco.bairro}
          />
        </Col>
        <Col md="12" lg="2">
          <TextField
            name="numeroLogradouro"
            label={"* Número"}
            value={execucaoFiscalizacao.numeroLogradouro}
            onBlur={handleOnBlurRegionalExecucaoFiscalizacao}
            onChange={onChange}
            invalid={!!errors.numeroLogradouro}
            disabled={disabledCamposEndereco.numeroLogradouro}
          />
        </Col>

        <Col md="12" lg={"12"}>
          <TextField
            name="regional_Id"
            type={"select"}
            options={listRegionais}
            label={"* Regional"}
            searchable
            onChange={(value) =>
              setExecucaoFiscalizacao({
                ...execucaoFiscalizacao,
                regional_Id: value ? value?.value?.toString() : "",
              })
            }
            value={
              execucaoFiscalizacao.regional_Id != null &&
              listRegionais.filter(
                (i) => i.id == execucaoFiscalizacao?.regional_Id
              )[0]
            }
            invalid={!!errors.regional_Id}
          />
        </Col>

        {!!execucaoFiscalizacao?.codigoItemFiscalizado && (
          <p>
            <span className="fw-bold">Codigo do item:</span>
            {execucaoFiscalizacao?.codigoItemFiscalizado ?? ""}
          </p>
        )}
        {!!dadosIntegracao &&
          !!dadosIntegracao?.dadosAdicionais &&
          dadosIntegracao.dadosAdicionais.map((value, key) => {
            return (
              <p key={key}>
                {" "}
                <span className="fw-bold"> {value.campo}: </span>
                {value.valor}
              </p>
            );
          })}
      </Row>

      {exibirDadosObitor === true && (
        <Row>
          <h5>Dados do Óbito</h5>
          <Col md="12" lg="5">
            <TextField
              name="nome"
              label={"Nome"}
              value={execucaoFiscalizacao?.dadosFalecido?.nome}
              onChange={onChangeDadosObitos}
              disabled={disabledCamposDadosFalecido?.nome}
            />
          </Col>
          <Col md="12" lg="3">
            <TextField
              name="cpf"
              label={"CPF"}
              value={execucaoFiscalizacao?.dadosFalecido?.cpf}
              onChange={onChangeDadosObitos}
              mask={mascaras.cpfMask}
              maxLength={14}
              disabled={disabledCamposDadosFalecido?.cpf}
            />
          </Col>
          <Col md="12" lg="2">
            <TextField
              name="dataNascimento"
              label={"Data Nascimento"}
              type={"date"}
              value={execucaoFiscalizacao?.dadosFalecido?.dataNascimento}
              onChange={onChangeDadosObitos}
              disabled={disabledCamposDadosFalecido?.dataNascimento}
            />
          </Col>
          <Col md="12" lg="2">
            <TextField
              name="dataFalecimento"
              label={"Data Falecimento"}
              type={"date"}
              value={execucaoFiscalizacao?.dadosFalecido?.dataFalecimento}
              onChange={onChangeDadosObitos}
              disabled={disabledCamposDadosFalecido?.dataFalecimento}
            />
          </Col>
        </Row>
      )}
    </>
  );
}

export default Identificacao;
